/*
  Galeria da página de produto — o Dawn deixa toda foto a partir da segunda em
  `loading="lazy"`. Numa galeria isso não é economia: a foto 2 só COMEÇA a baixar
  quando o visitante já está deslizando para ela, e o que aparece no caminho é o
  retângulo branco. Medido na LudMax: a segunda imagem chegava com
  `complete: false` e `naturalWidth: 0` depois da página inteira carregada.

  Aqui as vizinhas são buscadas em segundo plano — a atual continua sendo a
  única com prioridade alta, então o LCP não muda. `fetchPriority = 'low'` é o
  que mantém isso fora do caminho crítico.
*/
(() => {
  const JANELA = 2; // quantas fotos à frente e atrás manter prontas

  const aquece = (img) => {
    if (!img || img.dataset.baseAquecida) return;
    img.dataset.baseAquecida = 'true';
    // Se ainda não baixou, tira do lazy e pede em prioridade baixa.
    if (!img.complete || img.naturalWidth === 0) {
      if ('fetchPriority' in img) img.fetchPriority = 'low';
      img.loading = 'eager';
    }
  };

  const aquecerVizinhas = (galeria) => {
    const itens = [...galeria.querySelectorAll('.product__media-item')];
    if (itens.length < 2) return;

    const ativo = galeria.querySelector('.product__media-item.is-active');
    const centro = Math.max(0, itens.indexOf(ativo));

    for (let i = centro - JANELA; i <= centro + JANELA; i++) {
      if (i < 0 || i >= itens.length || i === centro) continue;
      aquece(itens[i].querySelector('img'));
    }
  };

  const ligar = (galeria) => {
    if (galeria.dataset.baseGaleria) return;
    galeria.dataset.baseGaleria = 'true';

    // Primeira rodada só depois que a página assentou, para não disputar
    // banda com a imagem principal (que é o LCP da PDP).
    const inicia = () => aquecerVizinhas(galeria);
    if (document.readyState === 'complete') setTimeout(inicia, 400);
    else window.addEventListener('load', () => setTimeout(inicia, 400), { once: true });

    // A cada troca de foto, adianta as próximas da nova posição.
    galeria.addEventListener('click', () => setTimeout(() => aquecerVizinhas(galeria), 50));
    const viewer = galeria.querySelector('[id^="GalleryViewer"]');
    viewer?.addEventListener('slideChanged', () => aquecerVizinhas(galeria));
  };

  const varrer = () => document.querySelectorAll('media-gallery').forEach(ligar);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', varrer);
  else varrer();

  // O editor de tema recria a seção a cada alteração.
  document.addEventListener('shopify:section:load', varrer);
})();
